import { useSearchParams } from "react-router-dom";
import { internalOrgIdSearchParamKey } from "@/components/unauthorized-pages/common/utils/constants/constants";
import { useAppSelector } from "@/store/hooks";
import { internalOrgQuarterStartMonthSelector } from "@/store/common/selectors/internal/internalOrgQuarterStartMonthSelector";
import { PreDefinedRanges } from "@/components/common/date-range-picker/utils/constants/types";
import { internalAllDateRangesByQuarterStartMonthSelector } from "@/store/common/selectors/internal/internalAllDateRangesByQuarterStartMonthSelector";

type ReturnType = {
  quarterStartMonth: number | undefined;
  ranges: PreDefinedRanges;
};

export const useInternalQuarterStartMonthHook = (): ReturnType => {
  const [searchParams] = useSearchParams();
  const organisationId = searchParams.get(internalOrgIdSearchParamKey) ?? null;
  const quarterStartMonth = useAppSelector((state) =>
    internalOrgQuarterStartMonthSelector(state, organisationId ?? ""),
  );
  const ranges = useAppSelector((state) =>
    internalAllDateRangesByQuarterStartMonthSelector(
      state,
      organisationId ?? "",
    ),
  );

  return {
    quarterStartMonth: quarterStartMonth,
    ranges: ranges,
  };
};
